<style scoped>
    @import url("../../../styles/contadorAguaPage/v3/dialogC.scss");
</style>

<template>
    <div class="box_dialogC">

        <v-icon class="mt-4" :style="{'color':'rgb(31,122,177)'}">{{ icon }}</v-icon>

        <div class="tit">{{ t }}</div>

        <div class="subtit mt-4">
            {{ msgFromInput }}
        </div>

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    props:['t','icon','flagStrTipoDialog','msgFromInput'],

    data() {
        return {
        }
    },

    created() {
        // -- Apenas retornar a emissão da desabilitação do dialog com a msg erro input.
        setTimeout(() => {
            this.$emit('fromInput',[false,'currentInput',this.flagStrTipoDialog]) // desable dialog.
        },5000)
    }
}
</script>